import { Icon } from "@mui/material";

export const GMaterialIcon = ({ icon, filled = false, weight = 400 }) => (
  <Icon sx={{ fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24` }}>{icon}</Icon>
);
